var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnlocked = function SvgUnlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "unlocked_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#unlocked_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 20h12V10H6zm6-3q.825 0 1.412-.587Q14 15.825 14 15t-.588-1.412A1.93 1.93 0 0 0 12 13q-.825 0-1.412.588A1.93 1.93 0 0 0 10 15q0 .824.588 1.413Q11.175 17 12 17m-6 5q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20V10q0-.825.588-1.412A1.93 1.93 0 0 1 6 8h7V6q0-2.075 1.463-3.537Q15.926 1 18 1q1.775 0 3.1 1.075a5.04 5.04 0 0 1 1.75 2.7q.126.425-.163.825Q22.4 6 22 6q-.425 0-.7-.175t-.4-.575a3.2 3.2 0 0 0-1.062-1.6A2.8 2.8 0 0 0 18 3q-1.25 0-2.125.875A2.9 2.9 0 0 0 15 6v2h3q.824 0 1.413.588Q20 9.175 20 10v10q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22z"
  }))));
};
export default SvgUnlocked;